/**
 * Sanitize returnUrl to prevent open redirect attacks
 * Only allows same-origin absolute paths, prevents '//' and external URLs
 */
export function sanitizeReturnUrl(url?: string): string | undefined {
  if (!url) return undefined;
  return url.startsWith('/') && !url.startsWith('//') ? url : undefined;
}
